import { Component, OnInit, Output } from '@angular/core';
import { EventEmitter } from '@angular/core';
import { VehiclesService } from '@app/shared/services/vehicles.service';
import { SocietiesService } from '@app/shared/services/societies.service';
import { SessionService } from '@app/shared/services/session.service';
declare var UIkit: any;

@Component({
  selector: 'app-add-vehicle',
  templateUrl: './add-vehicle.component.html',
  styleUrls: ['./add-vehicle.component.scss']
})
export class AddVehicleComponent implements OnInit {

  public vehicle : any = {
    name : '',
    brand: '',
    model: '',
    vehicleFuel: '',
    vehicleCategeory: '',
    vehicleDetails: ''
  };
  public validated : boolean = false;
  public loading : boolean = false;
  public societies : Array<any> = [];
  public selectedSocietyId : number = 0;

  @Output() changed = new EventEmitter();

  constructor(
    private vehicleService: VehiclesService,
    private societyService: SocietiesService,
    public session: SessionService
  ) {}

  ngOnInit() {
    if (this.session.role.ability === 'super-admin') {
      this.societyService.getSocieties().then((res) => {
        this.societies = res;
      });
    }
  }

  validator() {
    let result : boolean = true;

    this.validated = false;
    if (this.vehicle.name.length === 0) {
      result = false;
    }
    if (this.session.role.ability === 'super-admin' && this.selectedSocietyId === 0) {
      result = false;
    }
    this.validated = result;
  }

  resetVariables() {
    this.vehicle = {
      name : '',
      brand: '',
      model: '',
      vehicleFuel: '',
      vehicleCategeory: '',
      vehicleDetails: ''
    };
    this.validated = false;
    this.selectedSocietyId = 0;
  }

  submit() {
    this.loading = true;
    this.vehicleService.addVehicle({
      name: this.vehicle.name,
      brand: this.vehicle.brand,
      model: this.vehicle.model,
      vehicleFuel: this.vehicle.vehicleFuel,
      vehicleCategeory: this.vehicle.vehicleCategeory,
      vehicleDetails: this.vehicle.vehicleDetails,
      idSocietyVop: this.selectedSocietyId || this.session.role.id
    }).then(() => {
      this.loading = false;
      this.changed.emit(null);
      UIkit.modal('#add-vehicle').hide();
      sessionStorage.removeItem('VehicleList');
      this.resetVariables();
    });
  }

}